<template>
    <div class="home">
        <div class="container">
            <div>
                Before starting to use this web application, please follow these steps as below:
            </div>
            <ul>
                <li>1) Open this application on <b>Google Chrome browser.</b></li>
                <li>2) Click the install button on top-right of browser.</li>
                <img src="../assets/demo.png">
                <li>3) Install this application to your desktop.</li>
            </ul>
        </div>
    </div>
</template>
<script>
export default {
    name: 'installPage',
    components: {

    },
    data() {
        return {
            code: '',
            deferredPrompt: null,
            installInterval: null
        }
    },
    mounted() {
      clearInterval(this.installInterval) 
      this.checkInstalled()
    },
    methods: {
      checkInstalled(){
        this.installInterval = setInterval(() => { 
          if(window.matchMedia('(display-mode: standalone)').matches){
            clearInterval(this.installInterval) 
            this.$router.push({ name: 'home' })
          }
        }, 5000);
      }
    }
}
</script>
<style scoped>
.container {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}

.box {
    height: 100px;
    width: 200px;
    background: #fff;
    padding: 50px;
    border-radius: 10px;
    position: relative;
    text-align: center;
}

li {
    list-style: none;
}
</style>